import React, { Fragment } from "react";

const Header = () => (
  <Fragment>
    <table style={{ width: "100%" }}>
      <tbody>
        <tr>
          <td>
            <img src="/assets/images/hdf/axa-logo.png" alt="AXA Logo" style={{ width: "100%" }} />
          </td>
        </tr>
        <tr>
          <td
            style={{
              textAlign: "left",
              fontWeight: "bold",
              fontSize: "24px",
              verticalAlign: "middle",
              maxWidth: "100%",
            }}
          >
            Employee Application For Employee Benefits Insurance 僱員福利保險參加表格
          </td>
        </tr>
      </tbody>
    </table>
    <br />
  </Fragment>
);

export default Header;



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Axa/AXAHD202404/Header.js